import React, { Fragment } from 'react'
import MediaQuery from 'react-responsive'
import { ToggleFeature, features } from 'features/ToggleFeature'

const Widgets = () => {
  return (
    <Fragment>
      <MediaQuery minDeviceWidth={426}>
        <ToggleFeature
          feature={features.ZendeskWebWidget}
          src={process.env.REACT_APP_ZENDESK_WEBWIDGET_URL} />
      </MediaQuery>
      <ToggleFeature
        feature={features.SalesForceWebWidget} />
    </Fragment>
  )
}

export default Widgets



// WEBPACK FOOTER //
// ./src/Widgets/index.js